import { httpGet } from '@/utils/helpers/httpHelperPartner';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import CONFIG from 'config';
import { GroupSelectOption, Option } from 'src/globalTypes/types';

export type ServiceCatType = {
  data: Array<{
    label: string;
    value: number;
    subCategories: Array<{
      label: string;
      value: number;
      subCategories: null;
    }>;
  }>;
};

export type LoadedFileType = {
  filePath: string;
  file?: any;
};

export type AddServiceFormDataType = {
  serviceName: string;
  serviceCategory: GroupSelectOption;
  defaultPrice: string;
  discountedPrice: string;
  startDate: string;
  endDate: string;
  webSite: string;
  serviceDescription: string;
  serviceArea: Array<Option>;
  campaignType: string;
  campaignCode: string;
  promoCodeFile: any;
};

export const initialState = {
  formData: {
    serviceName: '',
    serviceCategory: null as GroupSelectOption,
    defaultPrice: '',
    discountedPrice: '',
    startDate: new Date().toString(),
    endDate: '',
    webSite: '',
    serviceDescription: '',
    serviceArea: [] as Array<Option>,
    campaignType: '',
    campaignCode: '',
    promoCodeFile: null as any,
  },
  loading: false,
  error: false,
  serviceCategories: [] as GroupSelectOption[],
  loadedFile: null as LoadedFileType,
  fileToSend: null as any,
  isSubmitting: false,
  cities: [] as Array<Option>,
};

export const fetchCitiesAndServiceCategories: any = createAsyncThunk(
  'partnerServiceSlice/fetchCitiesAndServiceCategories',
  async () => {
    const data = await Promise.all([
      httpGet<{
        data: GroupSelectOption[];
      }>(CONFIG.ENDPOINTS.serviceCategories),
      await httpGet<{ data: Array<Option> }>(`${CONFIG.ENDPOINTS.cities}`),
    ]);

    return data;
  }
);

export const partnerServiceSlice = createSlice({
  name: 'partnerServiceSlice',
  initialState,
  reducers: {
    setLoadedFile: (state: any, action: any) => {
      state.loadedFile = action.payload;
    },
    toggleIsSubmitting: (state: any, action: any) => {
      state.isSubmitting = action.payload;
    },
    setFileToSend: (state: any, action: any) => {
      state.fileToSend = action.payload;
    },
    initializeStartDate: (state: any) => {
      state.formData.startDate = new Date().toString();
    },
    setFormData: (state: any, action: any) => {
      state.formData = action.payload;
    },
    cleanFormData: (state: any) => {
      state.formData = initialState.formData;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchCitiesAndServiceCategories.fulfilled,
      (state, action) => {
        state.serviceCategories = action.payload[0].data;
        state.cities = action.payload[1].data;
        state.loading = false;
      }
    );
    builder.addCase(fetchCitiesAndServiceCategories.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchCitiesAndServiceCategories.rejected, (state) => {
      state.error = true;
    });
  },
});

export const {
  setLoadedFile,
  toggleIsSubmitting,
  setFileToSend,
  initializeStartDate,
  setFormData,
  cleanFormData,
} = partnerServiceSlice.actions;

export default partnerServiceSlice.reducer;
